module.exports = __webpack_public_path__ + "img/Progress-Report-Process-4-mobile.8e0daa61.png";